var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "ec9d2d3bd2f1ade3b2171a435714f95c.png",
    width: 279,
    height: 267
});